import styled from 'styled-components';
import { BREAKPOINTS } from '../../../utils/constants/breakpoints';
import { mediaQuery } from '../../../utils/mediaQuery';

type IsErrorProp = {
  status: string;
};

type IInputContainer = {
  isFullWidth: boolean;
};

export const GenericCalculatorWrapper = styled.div`
  background: ${({ theme }) => theme.Calculator.calculatorWrapper.backgroundColor};
  padding: ${({ theme }) => theme.Calculator.calculatorWrapper.mobile.padding};
  font-family: Lato, sans-serif;
  font-style: normal;
  position: relative;
  max-width: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: ${BREAKPOINTS.desktop}px) {
    padding: ${({ theme }) => theme.Calculator.calculatorWrapper.desktop.padding};
  }
`;

export const GenericCalculatorHeader = styled.div`
  font-weight: 700;
  line-height: 20px;
  font-size: ${({ theme }) => theme.Calculator.calculatorHeader.mobile.fontSize};
  color: ${({ theme }) => theme.Calculator.calculatorHeader.mobile.color};

  @media (min-width: ${BREAKPOINTS.desktop}px) {
    line-height: 28px;
    font-size: ${({ theme }) => theme.Calculator.calculatorHeader.desktop.fontSize};
    color: ${({ theme }) => theme.Calculator.calculatorHeader.desktop.color};
  }
`;

export const CalculatorInputsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  align-items: baseline;
  column-gap: 8px;
  justify-content: space-between;

  @media (min-width: ${BREAKPOINTS.desktop}px) {
    column-gap: ${({ theme }) => theme.Calculator.inputContainer.superDesktopGap};
  }

  @media (min-width: ${BREAKPOINTS.desktop}px) and (max-width: ${BREAKPOINTS.superDesktop}px) {
    column-gap: ${({ theme }) => theme.Calculator.inputContainer.desktopGap};
  }

  ${mediaQuery.fallback(`
    flex-direction: column;
  `)}
`;

export const InputContainer = styled.div<IInputContainer>`
  width: calc(50% - 4px);
  margin-top: 8px;
  max-width: 600px;

  @media (min-width: ${BREAKPOINTS.desktop}px) {
    width: ${({ isFullWidth, theme }) => (isFullWidth ? '80%' : theme.Calculator.inputContainer.superDesktopWidth)};
  }

  @media (min-width: ${BREAKPOINTS.desktop}px) and (max-width: ${BREAKPOINTS.superDesktop}px) {
    width: ${({ isFullWidth, theme }) => (isFullWidth ? '80%' : theme.Calculator.inputContainer.desktopWidth)};
  }

  ${mediaQuery.fallback(`
   width: 100%;
   display: inline-block;
  `)};
`;

export const InputTitle = styled.div`
  display: inline-block;
  margin-bottom: ${({ theme }) => theme.Calculator.inputTitle.marginBottom};
  label {
    color: ${({ theme }) => theme.Calculator.inputTitle.color};
    font-size: 14px;
    font-weight: ${({ theme }) => theme.Calculator.inputTitle.fontWeight};
    line-height: ${({ theme }) => theme.Calculator.inputTitle.lineHeight};
  }
  svg {
    vertical-align: middle;
    cursor: pointer;
    margin-left: ${({ theme }) => theme.Calculator.infoIcon.marginLeft};
    margin-bottom: 2px;
    path {
      fill: ${({ theme }) => theme.Calculator.infoIcon.fillColor};
    }
  }
`;

export const CalculatorHelperLink = styled.a<IsErrorProp>`
  display: inline-block;
  cursor: pointer;
  text-decoration: ${({ theme }) => theme.Calculator.helperText.textDecoration};
  color: ${({ theme }) => theme.Calculator.helperText.color};
  font-weight: 400;
  font-size: 14px;
  line-height: ${({ theme }) => theme.Calculator.helperText.lineHeight};
  margin-top: ${({ theme, status }) => theme.Calculator.helperText[status].marginTop};
`;

export const EstimationWrapper = styled.div`
  flex-grow: 1;
  align-self: center;
  margin-top: 8px;
  box-sizing: border-box;
  @media (min-width: ${BREAKPOINTS.desktop}px) {
    align-self: flex-start;
  }
`;

export const EstimationContainer = styled.div`
  color: ${({ theme }) => theme.Calculator.estimationContainer.color};
  background: ${({ theme }) => theme.Calculator.estimationContainer.backgroundColor};
  padding: 8px;
  display: inline-block;
  label {
    font-weight: 700;
    font-size: 17px;
    line-height: 24px;
  }
`;

export const EstimationValueContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;

export const EstimationValue = styled.div`
  font-weight: 700;
  font-size: 28px;
  line-height: 36px;
  margin-right: 2px;
`;

export const EstimationUnit = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 28px;
`;

export const ResultIcon = styled.div`
  margin-left: 8px;
`;

export const PopoverTitle = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: ${({ theme }) => theme.Calculator.popover.title.color};
  text-align: left;
`;

export const PopoverBody = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 21px;
  color: ${({ theme }) => theme.Calculator.popover.body.color};
  text-align: left;
`;

export const SubTitle = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #333333;
  margin-top: 8px;
`;
